import { render, staticRenderFns } from "./UserInquiryHistory.vue?vue&type=template&id=18d0dc7e&scoped=true"
import script from "./UserInquiryHistory.vue?vue&type=script&lang=js"
export * from "./UserInquiryHistory.vue?vue&type=script&lang=js"
import style0 from "./UserInquiryHistory.vue?vue&type=style&index=0&id=18d0dc7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0dc7e",
  null
  
)

export default component.exports